import { useQuery } from "@tanstack/react-query"
import { useOrganizationsService } from "@/modules/organizations/hooks/use-organizations"
import {
  getCandidatesPaged,
  type GetCandidatesPagedParams,
  type PagedCandidatesResponse,
} from "../infrastructure/candidate-service"

export const candidatesPagedKeys = {
  all: ["candidates-paged"] as const,
  list: (orgId: string, params: GetCandidatesPagedParams) =>
    ["candidates-paged", orgId, params] as const,
}

export function useCandidatesPaged(params: GetCandidatesPagedParams) {
  const { currentOrganization } = useOrganizationsService()
  const organizationId = currentOrganization?.id

  return useQuery<PagedCandidatesResponse>({
    queryKey: candidatesPagedKeys.list(organizationId ?? "", params),
    queryFn: () => getCandidatesPaged(organizationId!, params),
    enabled: !!organizationId,
  })
}
